// extracted by mini-css-extract-plugin
export var circle = "_28-2";
export var icon = "_28-a";
export var iconHighlight = "_28-0";
export var lg = "_28-8";
export var md = "_28-7";
export var outline = "_28-4";
export var sm = "_28-6";
export var square = "_28-1";
export var xl = "_28-9";
export var xs = "_28-5";
export var xxs = "_28-3";